module.exports = __webpack_public_path__ + "img/whats-new-6_jp.184b32b.jpg";